import { Button } from "components/ui/button";
import { planningInsightsBannerDismissed } from "data/local-storage-keys";
import { SquareScissors, X } from "lucide-react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import * as Routes from "routes";
import { getLocalStorage, setLocalStorage } from "utils/local-storage";

/**
 * A dismissible promo strip above the home grid announcing Planning Insights in
 * Geoscape Clip. Once dismissed it stays gone, remembered in localStorage. The
 * fill runs from the Clip brand teal (--brand-clip) to Hub's primary blue.
 */
export const PlanningInsightsBanner = () => {
  const history = useHistory();
  const [dismissed, setDismissed] = useState(() =>
    getLocalStorage(planningInsightsBannerDismissed, false),
  );

  if (dismissed) return null;

  const dismiss = () => {
    setLocalStorage(planningInsightsBannerDismissed, true);
    setDismissed(true);
  };

  return (
    <div
      data-testid="planning-insights-banner"
      className="flex items-center gap-3 rounded-lg bg-linear-to-r from-brand-clip/80 to-primary/80 py-2.5 pr-2.5 pl-3.5 text-white"
    >
      <span className="flex size-7 shrink-0 items-center justify-center rounded-md">
        <SquareScissors className="size-5" />
      </span>
      <p className="min-w-0 flex-1 text-sm">
        <span className="font-medium">Which planning rules apply?</span>{" "}
        <span className="font-semibold">Planning Insights</span> is now
        available in Geoscape Clip.
      </p>
      <div className="flex shrink-0 items-center gap-1">
        <Button
          variant="link"
          data-testid="planning-insights-banner-cta"
          onClick={() => history.push(Routes.clipUi)}
          className="text-sm font-semibold text-white "
        >
          Open in Clip →
        </Button>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Dismiss"
          data-testid="planning-insights-banner-dismiss"
          onClick={dismiss}
          className="text-white"
        >
          <X />
        </Button>
      </div>
    </div>
  );
};
